import Image from 'app/Components/Shared/Image/image';
import React, {forwardRef, memo, useEffect, useState} from "react";
import { Button, ButtonGroup, Dropdown, Form } from "react-bootstrap";
import MobileCheckboxPopup from "app/Components/Page/CellcomCareersPage/Shared/Utils/MobileCheckBox/MobileCheckBox";

// type item string
//    const items = [
//         { id: "em", label: "Exact Mass", checked: true },
//         { id: "f", label: "Formula", checked: true },
//         { id: "mw", label: "Molecular Weight", checked: true },
//         { id: "cp1", label: "Custom Property 1", checked: true },
//         { id: "cp2", label: "Custom Property 2", checked: true },
//         { id: "cp3", label: "Custom Property 3", checked: true },
//         { id: "cp4", label: "Custom Property 4", checked: true },
//         { id: "cp5", label: "Custom Property 5", checked: true },
//         { id: "cp6", label: "Custom Property 6", checked: true },
//         { id: "cp7", label: "Custom Property 7", checked: true },
//         { id: "cp8", label: "Custom Property 8", checked: true }
//     ];

// type item object
// const item = [
//     {
//         "reigon": "מרכז",
//         "cities": [
//             {
//                 "name": "פתח תקווה"
//             },
//             {
//                 "name": "נתניה"
//             }
//         ]
//     },
//     {
//         "reigon": "צפון",
//         "cities": [
//             {
//                 "name": "טבריה"
//             },
//             {
//                 "name": "מטולה"
//             }
//         ]
//     }
// ]
const CheckboxMenu = forwardRef(
    ({ children, style, className, 'aria-labelledby': labeledBy, onSelectAll, onSelectNone, handleChange }, ref) => {
        return (
            <div ref={ref} style={style} className={`${className} CheckboxMenu`} aria-labelledby={labeledBy}>
                <div className="d-flex flex-column" style={{ maxHeight: 'calc(100vh)', overflow: 'none',padding :'12px 0 12px 0' }}>
                    <ul className="list-unstyled flex-shrink mb-0" style={{ overflow: 'auto' }}>
                        {children}
                    </ul>
                    <div className="dropdown-item border-top pt-2 pb-0">
                        <ButtonGroup size="sm">
                            <Button variant="link" onClick={onSelectNone}>
                                נקה הכל
                            </Button>
                            <Button variant="link" onClick={onSelectAll}>
                                בחר
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>
            </div>
        );
    }
);

const CheckDropdownItem = forwardRef(({ children, id, checked, onChange }, ref) => {
    const handleChange = (e) => {
        e.persist();
        onChange && onChange(id, e);
    };
    return (
        <Form.Group ref={ref} className="dropdown-item mb-0" controlId={id}>
            <Form.Check
                type="checkbox"
                label={children}
                checked={checked}
                onChange={handleChange}
                style={{
                }}
            />
            <span></span>
        </Form.Group>
    );
});

const CheckboxDropdown = ({
                            count,
                            icon,
                            title,
                            items,
                            handleChecked,
                            handleSelectAll,
                            handleSelectNone,
                            type
                          }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const handleToggle = () => setShowDropdown(!showDropdown);
  const handleCloseDropdown = () => setShowDropdown(false);

  useEffect(() => {
    function reportWindowSize() {
      setIsMobile(window.innerWidth < 767);
    }

    window.addEventListener("resize", reportWindowSize);

    return () => window.removeEventListener("resize", reportWindowSize);
  }, []);

  return (
    <>
      <Dropdown onToggle={handleToggle} className={"checkbox-dropdown"} show={showDropdown}>
        <Dropdown.Toggle as={Button} variant="light">
          <Image src={icon} alt={"dropdown_icon"} />
          {title}
        </Dropdown.Toggle>
        {!isMobile ? (
          <Dropdown.Menu
            as={CheckboxMenu}
            onSelectAll={() => {
              handleSelectAll();
              handleCloseDropdown();
            }}
            onSelectNone={() => {
              handleSelectNone();
              handleCloseDropdown();
            }}
          >
            {items.map((i) => (
              <Dropdown.Item
                key={i.id}
                as={CheckDropdownItem}
                id={i.id}
                checked={i.checked}
                onChange={handleChecked}
              >
                {i.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        ) : (
          <MobileCheckboxPopup
            showPopup={showDropdown}
            onClose={handleCloseDropdown}
            title={type === "Location" ? "סינון לפי מיקום" : "סינון לפי היקף משרה"}
            items={items}
            handleChecked={handleChecked}
            onSelectAll={() => {
              handleSelectAll();
              handleCloseDropdown();
            }}
            onSelectNone={() => {
              handleSelectNone();
              handleCloseDropdown();
            }}
          />
        )}
      </Dropdown>
    </>
  );
};

export default CheckboxDropdown;
